
export default function ButtonGrid (props)
{
    return (
	<div className="d-flex justify-content-between w-100 gap-2">
	    {props.children}
	</div>
    );
}

function Left (props)
{
    return (
	<div className="d-flex flex-wrap justify-content-start align-items-end gap-2">
	    {props.children}
	</div>
    );
}

function Right (props)
{
    return (
	<div className="d-flex flex-wrap justify-content-end align-items-end gap-2">
	    {props.children}
	</div>
    );
}

ButtonGrid.Left = Left;
ButtonGrid.Right = Right;
